import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthModal from '../components/AuthModal';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import likeIcon from '../assets/Like_icon.png';
import unLikeIconImage from '../assets/unLike_icon.png';
import helloImage from '../assets/hello.png';
import topSecImage from '../assets/TopSec.png';
// Коллекция 1 - изображения
import col1_img1 from '../assets/col1_img1.jpg';
import col1_img2 from '../assets/col1_img2.jpg';
import col1_img3 from '../assets/col1_img3.jpg';
import col1_img4 from '../assets/col1_img4.jpg';
import col1_img5 from '../assets/col1_img5.jpg';
import col1_img6 from '../assets/col1_img6.jpg';
import col1_img7 from '../assets/col1_img7.jpg';
import col1_img8 from '../assets/col1_img8.jpg';
import col1_background from '../assets/col1_background.jpg';
// Коллекция 2 - изображения
import col2_img1 from '../assets/col2_img1.jpg';
import col2_img2 from '../assets/col2_img2.jpg';
import col2_img3 from '../assets/col2_img3.jpg';
import col2_img4 from '../assets/col2_img4.jpg';
import col2_img5 from '../assets/col2_img5.jpg';
import col2_img6 from '../assets/col2_img6.jpg';
import col2_img7 from '../assets/col2_img7.jpg';
import col2_img8 from '../assets/col2_img8.jpg';
import col2_img9 from '../assets/col2_img9.jpg';
import col2_background from '../assets/col2_background.jpg';
// Коллекция 3 - изображения
import col3_img1 from '../assets/col3_img1.jpg';
import col3_background from '../assets/col3_background.jpg';
// Коллекция 4 - изображения
import col4_img1 from '../assets/col4_img1.jpg';
import col4_img2 from '../assets/col4_img2.jpg';
import col4_img3 from '../assets/col4_img3.jpg';
import col4_img4 from '../assets/col4_img4.jpg';
import col4_img5 from '../assets/col4_img5.jpg';
import col4_img6 from '../assets/col4_img6.jpg';
import col4_img7 from '../assets/col4_img7.jpg';
import col4_img8 from '../assets/col4_img8.jpg';
import col4_background from '../assets/col4_background.jpg';
// Коллекция 5 - изображения
import col5_img1 from '../assets/col5_img1.jpg';
import col5_background from '../assets/col5_background.jpg';
// Коллекция 6 - изображения
import col6_img1 from '../assets/col6_img1.jpg';
import col6_img2 from '../assets/col6_img2.jpg';
import col6_img3 from '../assets/col6_img3.jpg';
import col6_img4 from '../assets/col6_img4.jpg';
import col6_img5 from '../assets/col6_img5.jpg';
import col6_img6 from '../assets/col6_img6.jpg';
import col6_background from '../assets/col6_background.jpg';

import wonder from '../assets/col5_background.jpg';

import col1 from '../assets/col1_img1.jpg';
import col2 from '../assets/col2_img1.jpg';
import col3 from '../assets/col3_img1.jpg';
import col4 from '../assets/col4_img1.jpg';

export default function CollectionPage() {
  const [viewMode, setViewMode] = useState('grid');
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const navigate = useNavigate();
  const [dbCollections, setDbCollections] = useState([]);
  const [animatingLikeIndex, setAnimatingLikeIndex] = useState(null);
  const { user, addToCollections, removeFromCollections } = useAuth();

  // Состояние для изображений коллекций
  const [collectionImages, setCollectionImages] = useState({
    'cyberpank': [],
    'myth-cats': [],
    'energy-near-you': [],
    'spirits-above': []
  });

  // Ref для хранения актуальных изображений (для использования в интервале)
  const collectionImagesRef = useRef({
    'cyberpank': [],
    'myth-cats': [],
    'energy-near-you': [],
    'spirits-above': []
  });

  // Ref для хранения текущих URL изображений (для использования в интервале)
  const currentImageUrlsRef = useRef({
    'cyberpank': col1,
    'myth-cats': col2,
    'energy-near-you': col3,
    'spirits-above': col4
  });

  // Состояние для текущих индексов изображений каждой коллекции
  const [currentImageIndex, setCurrentImageIndex] = useState({
    'cyberpank': 0,
    'myth-cats': 0,
    'energy-near-you': 0,
    'spirits-above': 0
  });

  // Состояние для текущих URL изображений (для принудительного обновления)
  const [currentImageUrls, setCurrentImageUrls] = useState({
    'cyberpank': col1,
    'myth-cats': col2,
    'energy-near-you': col3,
    'spirits-above': col4
  });

  // Состояние для отслеживания анимации слайда
  const [slideDirection, setSlideDirection] = useState({
    'cyberpank': 'idle',
    'myth-cats': 'idle',
    'energy-near-you': 'idle',
    'spirits-above': 'idle'
  });

  // Состояние для предыдущих изображений (для анимации)
  const [previousImageUrls, setPreviousImageUrls] = useState({
    'cyberpank': col1,
    'myth-cats': col2,
    'energy-near-you': col3,
    'spirits-above': col4
  });

  // Ref для предыдущих изображений (для использования в интервале)
  const previousImageUrlsRef = useRef({
    'cyberpank': col1,
    'myth-cats': col2,
    'energy-near-you': col3,
    'spirits-above': col4
  });

  // Загрузка коллекций из БД для List View
  useEffect(() => {
    const fetchCollections = async () => {
      try {
        const response = await fetch('/api/collections');
        if (response.ok) {
          const data = await response.json();
          setDbCollections(data.collections || []);
          console.log('✅ Загружены коллекции из БД:', data.collections.length);
        } else {
          console.warn('⚠️ Не удалось загрузить коллекции из БД');
        }
      } catch (error) {
        console.error('❌ Ошибка загрузки коллекций:', error);
      }
    };

    fetchCollections();
  }, []);

  // Загрузка изображений коллекций из БД
  useEffect(() => {
    const fetchCollectionImages = async () => {
      const collectionSlugs = ['cyberpank', 'myth-cats', 'energy-near-you', 'spirits-above'];
      
      // Определяем, локально ли мы работаем (с проверкой на существование window)
      const isLocal = typeof window !== 'undefined' && (
        window.location.hostname === 'localhost' || 
        window.location.hostname === '127.0.0.1' || 
        window.location.hostname.startsWith('192.168.')
      );
      
      // Для локальной разработки используем импортированные изображения
      if (isLocal) {
        console.log('🔧 Локальный режим: используем импортированные изображения');
        const staticImages = {
          'cyberpank': [
            col1_img1,
            col1_img2,
            col1_img3,
            col1_img4,
            col1_img5,
            col1_img6,
            col1_img7,
            col1_img8
          ],
          'myth-cats': [
            col2_img1,
            col2_img2,
            col2_img3,
            col2_img4,
            col2_img5,
            col2_img6,
            col2_img7,
            col2_img8,
            col2_img9
          ],
          'energy-near-you': [
            col6_img1,
            col6_img2,
            col6_img3,
            col6_img4,
            col6_img5,
            col6_img6
          ],
          'spirits-above': [
            col4_img1,
            col4_img2,
            col4_img3,
            col4_img4,
            col4_img5,
            col4_img6,
            col4_img7,
            col4_img8
          ]
        };
        
        setCollectionImages(staticImages);
        collectionImagesRef.current = staticImages;
        
        const initialUrls = {
          'cyberpank': staticImages['cyberpank'][0] || col1,
          'myth-cats': staticImages['myth-cats'][0] || col2,
          'energy-near-you': staticImages['energy-near-you'][0] || col3,
          'spirits-above': staticImages['spirits-above'][0] || col4
        };
        setCurrentImageUrls(initialUrls);
        setPreviousImageUrls(initialUrls);
        currentImageUrlsRef.current = initialUrls;
        previousImageUrlsRef.current = initialUrls;
        console.log('🖼️ Установлены импортированные изображения. Количество:', {
          'cyberpank': staticImages['cyberpank'].length,
          'myth-cats': staticImages['myth-cats'].length,
          'energy-near-you': staticImages['energy-near-you'].length,
          'spirits-above': staticImages['spirits-above'].length
        });
        return;
      }
      
      // Для production используем API, но если API недоступен, используем fallback на статические изображения
      console.log('🌐 Production режим: загружаем изображения из API');
      
      try {
        const promises = collectionSlugs.map(async (slug) => {
          try {
            const apiUrl = `/api/collections/${slug}`;
            console.log(`📡 Запрос к API: ${apiUrl}`);
            
            const response = await fetch(apiUrl);
            
            // Проверяем, что ответ JSON, а не HTML
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
              console.warn(`⚠️ Получен не JSON ответ для ${slug}:`, contentType);
              return { slug, images: [] };
            }
            
            if (response.ok) {
              const data = await response.json();
              // Извлекаем изображения из NFT
              const images = data.collection?.nfts?.map(nft => nft.imagelink) || [];
              console.log(`✅ Загружены изображения для ${slug}:`, images.length, 'штук');
              return { slug, images };
            } else {
              console.warn(`⚠️ Не удалось загрузить коллекцию ${slug}:`, response.status);
            }
          } catch (error) {
            console.error(`❌ Ошибка загрузки коллекции ${slug}:`, error);
          }
          return { slug, images: [] };
        });

        const results = await Promise.all(promises);
        const imagesMap = {};
        results.forEach(({ slug, images }) => {
          imagesMap[slug] = images;
        });

        // Проверяем, есть ли хотя бы одно изображение
        const hasAnyImages = Object.values(imagesMap).some(images => images && images.length > 0);
        
        // Если все массивы пустые, используем fallback изображения
        if (!hasAnyImages) {
          console.warn('⚠️ API не вернул изображения, используем fallback');
          const fallbackImages = {
            'cyberpank': [col1_img1, col1_img2, col1_img3, col1_img4, col1_img5, col1_img6, col1_img7, col1_img8],
            'myth-cats': [col2_img1, col2_img2, col2_img3, col2_img4, col2_img5, col2_img6, col2_img7, col2_img8, col2_img9],
            'energy-near-you': [col6_img1, col6_img2, col6_img3, col6_img4, col6_img5, col6_img6],
            'spirits-above': [col4_img1, col4_img2, col4_img3, col4_img4, col4_img5, col4_img6, col4_img7, col4_img8]
          };
          setCollectionImages(fallbackImages);
          collectionImagesRef.current = fallbackImages;
          const fallbackUrls = {
            'cyberpank': fallbackImages['cyberpank'][0] || col1,
            'myth-cats': fallbackImages['myth-cats'][0] || col2,
            'energy-near-you': fallbackImages['energy-near-you'][0] || col3,
            'spirits-above': fallbackImages['spirits-above'][0] || col4
          };
          setCurrentImageUrls(fallbackUrls);
          setPreviousImageUrls(fallbackUrls);
          currentImageUrlsRef.current = fallbackUrls;
          previousImageUrlsRef.current = fallbackUrls;
          return;
        }

        console.log('📦 Загруженные изображения:', imagesMap);
        setCollectionImages(imagesMap);
        // Обновляем ref для использования в интервале
        collectionImagesRef.current = imagesMap;
        
        // Устанавливаем первые изображения для каждой коллекции (с fallback)
        const initialUrls = {
          'cyberpank': imagesMap['cyberpank']?.[0] || col1_img1 || col1,
          'myth-cats': imagesMap['myth-cats']?.[0] || col2_img1 || col2,
          'energy-near-you': imagesMap['energy-near-you']?.[0] || col6_img1 || col3,
          'spirits-above': imagesMap['spirits-above']?.[0] || col4_img1 || col4
        };
        setCurrentImageUrls(initialUrls);
        setPreviousImageUrls(initialUrls);
        currentImageUrlsRef.current = initialUrls;
        previousImageUrlsRef.current = initialUrls;
        console.log('🖼️ Установлены начальные изображения:', initialUrls);
      } catch (error) {
        console.error('❌ Ошибка загрузки коллекций:', error);
        // Fallback: используем импортированные изображения, если API недоступен
        console.log('🔄 Используем fallback изображения из-за ошибки API');
        const fallbackImages = {
          'cyberpank': [col1_img1, col1_img2, col1_img3, col1_img4, col1_img5, col1_img6, col1_img7, col1_img8],
          'myth-cats': [col2_img1, col2_img2, col2_img3, col2_img4, col2_img5, col2_img6, col2_img7, col2_img8, col2_img9],
          'energy-near-you': [col6_img1, col6_img2, col6_img3, col6_img4, col6_img5, col6_img6],
          'spirits-above': [col4_img1, col4_img2, col4_img3, col4_img4, col4_img5, col4_img6, col4_img7, col4_img8]
        };
        setCollectionImages(fallbackImages);
        collectionImagesRef.current = fallbackImages;
        const fallbackUrls = {
          'cyberpank': fallbackImages['cyberpank'][0] || col1,
          'myth-cats': fallbackImages['myth-cats'][0] || col2,
          'energy-near-you': fallbackImages['energy-near-you'][0] || col3,
          'spirits-above': fallbackImages['spirits-above'][0] || col4
        };
        setCurrentImageUrls(fallbackUrls);
        setPreviousImageUrls(fallbackUrls);
        currentImageUrlsRef.current = fallbackUrls;
      }
    };

    fetchCollectionImages();
  }, []);

  // Ref для хранения таймеров каждой коллекции
  const rotationTimersRef = useRef({});

  // Функция для получения случайной задержки от 4 до 9 секунд
  const getRandomDelay = () => {
    return 4000 + Math.random() * 5000; // От 4000 до 9000 мс
  };

  // Функция для переключения изображения одной коллекции
  const rotateCollectionImage = useCallback((slug) => {
    const currentImages = collectionImagesRef.current[slug];
    if (!currentImages || currentImages.length === 0) {
      return;
    }

    setCurrentImageIndex((prev) => {
      const currentIndex = prev[slug] !== undefined ? prev[slug] : 0;
      const nextIndex = (currentIndex + 1) % currentImages.length;
      const imageUrl = currentImages[nextIndex];
      const currentUrl = currentImageUrlsRef.current[slug];
      
      if (!imageUrl || imageUrl === currentUrl) {
        return { ...prev, [slug]: nextIndex };
      }

      console.log(`🔄 ${slug}: индекс ${currentIndex} -> ${nextIndex}`);

      // Сохраняем предыдущее изображение
      const previousUrl = currentUrl;
      const previousUrlsUpdate = { ...previousImageUrlsRef.current };
      previousUrlsUpdate[slug] = previousUrl;
      
      setPreviousImageUrls(previousUrlsUpdate);
      previousImageUrlsRef.current = previousUrlsUpdate;

      // Устанавливаем новое изображение
      const newUrls = { ...currentImageUrlsRef.current };
      newUrls[slug] = imageUrl;
      setCurrentImageUrls(newUrls);
      currentImageUrlsRef.current = newUrls;

      // Запускаем анимацию
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            setSlideDirection((prevDir) => ({
              ...prevDir,
              [slug]: 'sliding'
            }));
            console.log(`🖼️ Запущена анимация слайда для: ${slug}`);
            
            // После завершения анимации сбрасываем состояние
            setTimeout(() => {
              setSlideDirection((prevDir) => ({
                ...prevDir,
                [slug]: 'idle'
              }));
              
              // Обновляем previousImageUrls
              const finalPreviousUrls = { ...previousImageUrlsRef.current };
              finalPreviousUrls[slug] = imageUrl;
              setPreviousImageUrls(finalPreviousUrls);
              previousImageUrlsRef.current = finalPreviousUrls;
              
              console.log(`✅ Анимация завершена для ${slug}`);
            }, 600); // Длительность анимации
          }, 100); // Задержка перед началом анимации
        });
      });

      return { ...prev, [slug]: nextIndex };
    });
  }, []);

  // Функция для планирования следующего переключения коллекции
  const scheduleNextRotation = useCallback((slug) => {
    // Очищаем предыдущий таймер для этой коллекции
    if (rotationTimersRef.current[slug]) {
      clearTimeout(rotationTimersRef.current[slug]);
    }

    const delay = getRandomDelay();
    console.log(`⏰ Запланировано переключение ${slug} через ${Math.round(delay)}мс`);

    rotationTimersRef.current[slug] = setTimeout(() => {
      rotateCollectionImage(slug);
      // Планируем следующее переключение
      scheduleNextRotation(slug);
    }, delay);
  }, [rotateCollectionImage]);

  // Ротация изображений с случайными задержками от 4 до 9 секунд
  useEffect(() => {
    // Проверяем, есть ли хотя бы одна коллекция с изображениями
    const hasImages = Object.values(collectionImages).some(images => images.length > 0);
    
    if (!hasImages) {
      console.log('⏸️ Ротация не запущена: нет изображений. collectionImages:', collectionImages);
      return;
    }

    console.log('▶️ Запуск ротации изображений со случайными задержками (4-9 сек)');
    console.log('📦 Текущие изображения:', collectionImagesRef.current);

    // Запускаем ротацию для каждой коллекции с начальной случайной задержкой
    const collectionSlugs = Object.keys(collectionImagesRef.current);
    collectionSlugs.forEach((slug) => {
      const images = collectionImagesRef.current[slug];
      if (images && images.length > 1) {
        // Каждая коллекция начинает переключаться с разной задержкой
        const initialDelay = getRandomDelay();
        console.log(`🚀 Запуск ротации для ${slug} с начальной задержкой ${Math.round(initialDelay)}мс`);
        
        rotationTimersRef.current[slug] = setTimeout(() => {
          rotateCollectionImage(slug);
          scheduleNextRotation(slug);
        }, initialDelay);
      }
    });

    return () => {
      console.log('⏹️ Остановка ротации изображений');
      // Очищаем все таймеры
      Object.values(rotationTimersRef.current).forEach((timer) => {
        if (timer) clearTimeout(timer);
      });
      rotationTimersRef.current = {};
    };
  }, [collectionImages, rotateCollectionImage, scheduleNextRotation]);

  // Функция для получения текущего изображения коллекции
  const getCurrentImage = useCallback((slug, fallbackImage) => {
    // Используем состояние currentImageUrls для гарантированного обновления
    const currentUrl = currentImageUrls[slug];
    if (currentUrl) {
      return currentUrl;
    }
    
    // Fallback на вычисление из состояния
    const images = collectionImages[slug] || [];
    if (images.length > 0) {
      const index = currentImageIndex[slug] !== undefined ? currentImageIndex[slug] : 0;
      const imageUrl = images[index];
      if (!imageUrl) {
        return fallbackImage;
      }
      return imageUrl;
    }
    return fallbackImage;
  }, [collectionImages, currentImageIndex, currentImageUrls]);

  // Функция для рендеринга изображения со слайд-анимацией
  const renderSlidingImage = useCallback((slug, fallbackImage, style, onError) => {
    const currentImage = getCurrentImage(slug, fallbackImage);
    const previousImage = previousImageUrls[slug] || fallbackImage;
    const isSliding = slideDirection[slug] === 'sliding';
    const imagesAreDifferent = currentImage !== previousImage;
    
    // Извлекаем border из style для применения к контейнеру
    const { border, ...containerStyle } = style;
    const imageBorder = border || '4px solid #FE0000';
    
    // Если изображения одинаковые и не идет анимация, показываем только одно
    if (!imagesAreDifferent && !isSliding) {
      return (
        <div
          className="absolute"
          style={{
            ...containerStyle,
            overflow: 'hidden',
            zIndex: style.zIndex || 5,
            border: imageBorder
          }}
        >
          <img
            key={`${slug}-static-${currentImage}`}
            src={currentImage}
            alt={slug}
            className="absolute"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              top: 0,
              left: 0
            }}
            onError={onError}
          />
        </div>
      );
    }
    
    // Определяем позиции для анимации
    // Новое изображение всегда начинается справа (100%), если изображения разные
    // При анимации оно перемещается в центр (0%)
    const newImagePosition = imagesAreDifferent 
      ? (isSliding ? '0%' : '100%')  // Если разные: справа до анимации, в центре во время анимации
      : '0%';  // Если одинаковые: всегда в центре
    
    // Предыдущее изображение находится в центре (0%), при анимации уезжает влево (-100%)
    const prevImagePosition = isSliding ? '-100%' : '0%';
    
    // Если изображения разные или идет анимация, показываем оба слоя
    return (
      <div
        className="absolute"
        style={{
          ...containerStyle,
          overflow: 'hidden',
          zIndex: style.zIndex || 5,
          border: imageBorder
        }}
      >
        {/* Предыдущее изображение (уезжает влево при анимации) */}
        <img
          key={`${slug}-prev-${previousImage}`}
          src={previousImage}
          alt={`${slug} previous`}
          className="absolute"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transform: `translateX(${prevImagePosition})`,
            transition: isSliding ? 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)' : 'none',
            top: 0,
            left: 0,
            zIndex: 1
          }}
          onError={onError}
        />
        
        {/* Новое/текущее изображение (выезжает справа при анимации) */}
        <img
          key={`${slug}-current-${currentImage}`}
          src={currentImage}
          alt={slug}
          className="absolute"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transform: `translateX(${newImagePosition})`,
            transition: isSliding ? 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)' : 'transform 0s linear',
            top: 0,
            left: 0,
            zIndex: 2,
            willChange: 'transform'
          }}
          onError={onError}
        />
      </div>
    );
  }, [getCurrentImage, previousImageUrls, slideDirection]);

  // Проверка, лайкнута ли коллекция
  const isCollectionLiked = (slug) => {
    // Если пользователь не залогинен, всегда возвращаем false
    if (!user) {
      return false;
    }
    // Если у пользователя нет массива коллекций, возвращаем false
    if (!Array.isArray(user.collections)) {
      return false;
    }
    return user.collections.some((col) => col.slug === slug);
  };

  // Обработчик переключения лайка
  const handleLikeToggle = async (e, slug, index) => {
    e.stopPropagation(); // Предотвращаем переход на страницу коллекции
    
    if (!user) {
      setIsAuthModalOpen(true);
      return;
    }

    const currentlyLiked = isCollectionLiked(slug);

    // Запускаем анимацию только при добавлении лайка
    if (!currentlyLiked) {
      setAnimatingLikeIndex(index);
      setTimeout(() => setAnimatingLikeIndex(null), 600); // Длительность анимации
    }

    if (!currentlyLiked) {
      const result = await addToCollections(slug);
      if (!result.success) {
        console.error('Ошибка добавления в collections:', result.message);
        if (result.requireAuth) {
          setIsAuthModalOpen(true);
        }
        setAnimatingLikeIndex(null);
      }
    } else {
      const result = await removeFromCollections(slug);
      if (!result.success) {
        console.error('Ошибка удаления из collections:', result.message);
      }
    }
  };

  // Функция для получения данных коллекции из БД по slug
  const getCollectionFromDB = (slug) => {
    return dbCollections.find(col => col.slug === slug);
  };

  // Массив данных коллекций с разными изображениями
  // В будущем это можно будет заменить на данные из БД
  const collections = [
    {
      id: 'cyberpank',
      image: col1_img1, // Первая фотка первой коллекции
      background: col1_background,
      route: '/collection/cyberpank',
      title: 'Cyberpank',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 0,
      createdBy: 'Bojar',
      isLiked: false
    },
    {
      id: 'myth-cats',
      image: col2_img1, // Первая фотка второй коллекции
      background: col2_background,
      route: '/collection/myth-cats',
      title: 'Myth Cats',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 0,
      createdBy: 'Bojar',
      isLiked: false
    },
    {
      id: 'future-illusion',
      image: col3_img1, // Первая фотка третьей коллекции
      background: col3_background,
      route: '/collection/future-illusion',
      title: 'Future Illusion',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 0,
      createdBy: 'Bojar',
      isLiked: false
    },
    {
      id: 'spirits-above',
      image: col4_img1, // Первая фотка четвертой коллекции
      background: col4_background,
      route: '/collection/spirits-above',
      title: 'Spirits Above',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 0,
      createdBy: 'Bojar',
      isLiked: false
    },
    {
      id: 'wonder',
      image: col5_img1, // Первая фотка пятой коллекции
      background: col5_background,
      route: '/collection/wonder',
      title: 'Wonder',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 0,
      createdBy: 'Bojar',
      isLiked: false
    },
    {
      id: 'energy-near-you',
      image: col6_img1, // Первая фотка шестой коллекции
      background: col6_background,
      route: '/collection/energy-near-you',
      title: 'Energy Near You',
      collectionAmount: 11,
      bestOffer: '11 sol',
      followers: 0,
      createdBy: 'Bojar',
      isLiked: false
    }
  ];

  return (
    <div className="h-screen bg-[#1E1E1E] text-white main-font flex flex-col overflow-hidden">
      <Header />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar activePage="collection" />

        {/* Main Content */}
        <main className="flex-1 bg-[#1E1E1E] flex flex-col overflow-hidden">
          {/* Scrollable Content Area */}
          <div className="flex-1 overflow-y-auto overflow-x-hidden">
            <div style={{ maxWidth: '86.51vw', margin: '0' }}>
          {/* Top Section with TopSec background */}
          <div
            style={{
              backgroundImage: `url(${topSecImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              position: 'relative',
              paddingTop: 'clamp(20px, 1.88vw, 36px)',
              paddingBottom: 'clamp(20px, 2.08vw, 40px)',
              width: '100%'
            }}
          >
          {/* Collections Row Section */}
          <div 
              className="relative"
              style={{
                width: '100%',
                maxWidth: 'clamp(800px, 86.46vw, 1660px)',
                height: 'clamp(60px, 4.38vw, 84px)',
                backgroundColor: '#181818',
                marginTop: '0',
                display: 'flex',
                gap: 'clamp(30px, 3.18vw, 61px)',
                paddingLeft: 'clamp(40px, 5vw, 96px)',
                overflow: 'hidden'
              }}
            >
            {/* Collection Card 1 - Most Visited */}
            <div 
              className="border border-[#FF0000] flex-shrink-0 relative cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/collection/future-illusion')}
              style={{
                width: 'clamp(140px, 9.9vw, 190px)',
                height: '100%',
                backgroundColor: 'transparent'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}
              >
                Most Visited Collection
              </div>
              
              <img 
                src={require('../assets/1.png')}
                alt="Icon"
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(24px, 1.98vw, 38px)',
                  width: 'clamp(12px, 0.94vw, 18px)',
                  height: 'clamp(12px, 0.94vw, 18px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(22px, 1.82vw, 35px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Future Illusion
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Bojar
              </div>
            </div>

            {/* Collection Card 2 - New Top */}
            <div 
              className="border border-[#FF0000] flex-shrink-0 relative cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/collection/myth-cats')}
              style={{
                width: 'clamp(140px, 9.9vw, 190px)',
                height: '100%',
                backgroundColor: 'transparent'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}
              >
                New Top Collection
              </div>
              
              <img 
                src={require('../assets/2.png')}
                alt="Icon"
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(24px, 1.98vw, 38px)',
                  width: 'clamp(24px, 1.88vw, 36px)',
                  height: 'clamp(13px, 1.04vw, 20px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(32px, 2.71vw, 52px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Myth Cats
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Luna
              </div>
            </div>

            {/* Collection Card 3 - Trending */}
            <div 
              className="border border-[#FF0000] flex-shrink-0 relative cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/collection/future-illusion')}
              style={{
                width: 'clamp(140px, 9.9vw, 190px)',
                height: '100%',
                backgroundColor: 'transparent'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}
              >
                Trending
              </div>
              
              <img 
                src={require('../assets/3.png')}
                alt="Icon"
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(24px, 1.98vw, 38px)',
                  width: 'clamp(12px, 0.94vw, 18px)',
                  height: 'clamp(12px, 0.94vw, 18px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(22px, 1.82vw, 35px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Future Illusion
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Bojar
              </div>
            </div>

            {/* Collection Card 4 - Ideal Relativian */}
            <div 
              className="border border-[#FF0000] flex-shrink-0 relative cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/collection/spirits-above')}
              style={{
                width: 'clamp(140px, 9.9vw, 190px)',
                height: '100%',
                backgroundColor: 'transparent'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '90%'
                }}
              >
                 Week Redaction Choose
              </div>
              
              <img 
                src={require('../assets/4.png')}
                alt="Icon"
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(24px, 1.98vw, 38px)',
                  width: 'clamp(12px, 0.94vw, 18px)',
                  height: 'clamp(12px, 0.94vw, 18px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(22px, 1.82vw, 35px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Spirits Above
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Five
              </div>
            </div>

            {/* Collection Card 5 - Today Art */}
            <div 
              className="border border-[#FF0000] flex-shrink-0 relative cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => navigate('/collection/cyberpank')}
              style={{
                width: 'clamp(140px, 9.9vw, 190px)',
                height: '100%',
                backgroundColor: 'transparent'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}
              >
                Today Art
              </div>
              
              <img 
                src={require('../assets/5.png')}
                alt="Icon"
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(24px, 1.98vw, 38px)',
                  width: 'clamp(12px, 0.94vw, 18px)',
                  height: 'clamp(12px, 0.94vw, 18px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(22px, 1.82vw, 35px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Cyberpank
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Elsa
              </div>
            </div>

            {/* Divider */}
            <div 
              className="flex-shrink-0"
              style={{
                width: '1px',
                height: 'clamp(40px, 3.13vw, 60px)',
                backgroundColor: 'rgba(217, 217, 217, 0.6)',
                alignSelf: 'center'
              }}
            />

            {/* Группа: Hello NFT + полоска */}
            <div 
              className="flex-shrink-0"
              style={{
                display: 'flex',
                gap: 'clamp(4px, 0.42vw, 8px)', 
                height: '100%'
              }}
            >
              {/* Special Card - Hello NFT */}
              <div 
                className="flex-shrink-0 relative"
                style={{
                  width: 'clamp(140px, 9.9vw, 190px)',
                  height: '100%',
                  backgroundColor: '#5C6FFF'
                }}
              >
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(6px, 0.52vw, 10px)',
                  top: 'clamp(6px, 0.52vw, 10px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.63vw, 12px)',
                  color: 'rgba(255, 255, 255, 0.6)'
                }}
              >
                Best NFT Story
              </div>
              
              <img 
                src={helloImage}
                alt="Hello NFT"
                style={{
                  position: 'absolute',
                  left: 'clamp(12px, 0.99vw, 19px)',
                  top: 'clamp(21px, 1.72vw, 33px)',
                  width: 'clamp(26px, 2.08vw, 40px)',
                  height: 'clamp(26px, 2.08vw, 40px)'
                }}
              />
              
              <div 
                style={{
                  position: 'absolute',
                  left: 'clamp(44px, 3.65vw, 70px)',
                  top: 'clamp(23px, 1.93vw, 37px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 0.83vw, 16px)',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}
              >
                Hello NFT
              </div>
              
              <div 
                style={{
                  position: 'absolute',
                  right: 'clamp(6px, 0.52vw, 10px)',
                  bottom: 'clamp(4px, 0.42vw, 8px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.52vw, 10px)',
                  color: 'rgba(255, 255, 255, 0.7)'
                }}
              >
                By Five
              </div>
            </div>

            {/* Accent strip */}
            <div 
              className="flex-shrink-0"
              style={{
                width: 'clamp(30px, 2.05vw, 40px)',
                height: '100%',
                backgroundColor: 'rgba(92, 111, 255, 0.7)'
              }}
            />
          </div>
          </div>

          {/* eyes */}    
          <div 
            className="relative"
            style={{
              marginLeft: 'clamp(35px, 3.65vw, 70px)',
              marginTop: 'clamp(30px, 3.13vw, 60px)',
              width: 'clamp(390px, 40.68vw, 781px)',
              height: 'clamp(170px, 17.71vw, 340px)'
            }}
          >
            <div className="overflow-hidden" style={{ width: '100%', height: '100%' }}>
              <img 
                src={wonder}
                alt="Crypto InfiniG"
                className="transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
                onClick={() => navigate('/collection/wonder')}
              />
            </div>
            
            {/* Wonder overlay frame */}
            <div
              className="absolute"
              style={{
                left: 'clamp(15px, 1.56vw, 30px)',
                top: 'clamp(106px, 11.09vw, 213px)',
                width: 'clamp(185px, 19.27vw, 370px)',
                height: 'clamp(55px, 5.73vw, 110px)',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                border: '1px solid #CC0000',
                borderRadius: '2px',
                padding: 'clamp(6px, 0.94vw, 12px) clamp(8px, 1.25vw, 16px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                pointerEvents: 'none'
              }}
            >
              <div
                style={{
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF',
                  marginBottom: 'clamp(3px, 0.31vw, 6px)'
                }}
              >
                Wonder
              </div>
              <div
                style={{
                  fontFamily: 'Inder',
                  fontWeight: 400,
                  fontSize: 'clamp(7px, 0.73vw, 14px)',
                  color: 'rgba(255, 255, 255, 0.7)',
                  lineHeight: 1.3
                }}
              >
                The collection wonder world contains five parts<br />
                what represents a city of energy flowing above<br />
                houses and watching dreams of people.
              </div>
            </div>
            
            <div 
              className="absolute bg-[#1A1A1A]"
              style={{
                right: '0',
                top: '0',
                width: 'clamp(90px, 9.38vw, 180px)',
                height: '100%'
              }}
            >
              <div 
                className="absolute bg-[#CC0000] flex items-center justify-center"
                style={{
                  left: '0',
                  top: 'clamp(14px, 1.46vw, 28px)',
                  width: '100%',
                  height: 'clamp(19px, 1.98vw, 38px)'
                }}
              >
                <span 
                  style={{
                    fontFamily: 'Keania One',
                    fontWeight: 400,
                    fontSize: 'clamp(8px, 0.83vw, 16px)',
                    color: '#FFFFFF'
                  }}
                >
                  Wonder
                </span>
              </div>

              <div className="absolute" style={{ 
                left: 'clamp(5px, 0.52vw, 10px)', 
                top: 'clamp(48px, 5vw, 96px)' 
              }}>
                <div 
                  style={{
                    width: 'clamp(5.5px, 0.57vw, 11px)',
                    height: 'clamp(5.5px, 0.57vw, 11px)',
                    backgroundColor: '#D9D9D9'
                  }}
                />
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(45.5px, 4.74vw, 91px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                Items
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(69px, 7.19vw, 138px)',
                  top: 'clamp(45.5px, 4.74vw, 91px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                5
              </div>

              <div className="absolute" style={{ 
                left: 'clamp(5px, 0.52vw, 10px)', 
                top: 'clamp(65.5px, 6.82vw, 131px)' 
              }}>
                <div 
                  style={{
                    width: 'clamp(5.5px, 0.57vw, 11px)',
                    height: 'clamp(5.5px, 0.57vw, 11px)',
                    backgroundColor: '#D9D9D9'
                  }}
                />
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(63.5px, 6.61vw, 127px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                Top price
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(62px, 6.46vw, 124px)',
                  top: 'clamp(63.5px, 6.61vw, 127px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                1.4 sol
              </div>

              <div className="absolute" style={{ 
                left: 'clamp(5px, 0.52vw, 10px)', 
                top: 'clamp(82px, 8.54vw, 164px)' 
              }}>
                <div 
                  style={{
                    width: 'clamp(5.5px, 0.57vw, 11px)',
                    height: 'clamp(5.5px, 0.57vw, 11px)',
                    backgroundColor: '#D9D9D9'
                  }}
                />
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(79.5px, 8.28vw, 159px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                Floor price
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(63px, 6.56vw, 126px)',
                  top: 'clamp(80px, 8.33vw, 160px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                1.4 sol
              </div>

              <div className="absolute" style={{ 
                left: 'clamp(5px, 0.52vw, 10px)', 
                top: 'clamp(99px, 10.31vw, 198px)' 
              }}>
                <div 
                  style={{
                    width: 'clamp(5.5px, 0.57vw, 11px)',
                    height: 'clamp(5.5px, 0.57vw, 11px)',
                    backgroundColor: '#D9D9D9'
                  }}
                />
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(96.5px, 10.05vw, 193px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                Listed
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(70.5px, 7.34vw, 141px)',
                  top: 'clamp(97px, 10.1vw, 194px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                1
              </div>

              <div className="absolute" style={{ 
                left: 'clamp(5px, 0.52vw, 10px)', 
                top: 'clamp(116px, 12.08vw, 232px)' 
              }}>
                <div 
                  style={{
                    width: 'clamp(5.5px, 0.57vw, 11px)',
                    height: 'clamp(5.5px, 0.57vw, 11px)',
                    backgroundColor: '#D9D9D9'
                  }}
                />
              </div>
              <div 
                className="absolute"
                style={{
                  left: 'clamp(19.5px, 2.03vw, 39px)',
                  top: 'clamp(113.5px, 11.82vw, 227px)',
                  fontFamily: 'Keania One',
                  fontWeight: 400,
                  fontSize: 'clamp(8px, 0.83vw, 16px)',
                  color: '#FFFFFF'
                }}
              >
                By bojar
              </div>
            </div>

            {/* upcoming collections - внутри relative контейнера */}
            <div 
  className="absolute"
  style={{
    left: '43vw',
    top: '0vh',
    width: '17.45vw',
    height: '7.29vw',
    backgroundColor: '#1C1A1A'
  }}
>
  <div 
    style={{
      position: 'absolute',
      left: '3.96vw',
      top: '3.02vw',
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: '0.73vw',
      color: '#FFFFFF'
    }}
  >
    UPCOMING COLLECTITON'S
  </div>
  
  <div 
    style={{
      position: 'absolute',
      left: '3.07vw',
      top: '4.48vw',
      width: '11.35vw',
      height: '0.1vw',
      backgroundColor: '#CC0000'
    }}
  >
    <div 
      style={{
        position: 'absolute',
        right: '-0.52vw',
        top: '-0.21vw',
        width: '0',
        height: '0',
        borderLeft: '0.52vw solid #CC0000',
        borderTop: '0.26vw solid transparent',
        borderBottom: '0.26vw solid transparent'
      }}
    />
  </div>
</div>

<div 
  className="absolute"
  style={{
    left: '43vw',
    top: '16vh',
    width: '17.45vw',
    height: '7.29vw',
    backgroundColor: '#1C1A1A'
  }}
>
  <p 
    style={{
      position: 'absolute',
      left: '1.41vw',
      top: '2.55vw',
      right: '1.51vw',
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: '0.63vw',
      color: '#FFFFFF',
      opacity: 0.66,
      lineHeight: '1.4',
      width: 'calc(100% - 1.92vw)'
    }}
  >
    Some not a wise words, wile it not wise you think some things and there is someone not snowboarding enough.
  </p>
</div>

{renderSlidingImage('cyberpank', col1, {
    left: '62.5vw',
    top: '-0.5vh',
    width: '7.29vw',
    height: '7.29vw',
    border: '4px solid #FE0000',
    zIndex: 5
  }, (e) => {
    console.error('❌ Ошибка загрузки изображения CyberPunk:', e.target.src);
    e.target.onerror = null;
    e.target.src = col1;
  })}

<div 
  className="absolute flex items-center justify-center"
  style={{
    left: 'calc(62.5vw + clamp(2px, 0.26vw, 4px))',
    top: 'calc(-0.5vh + 7.29vw - clamp(28px, 2.08vw, 40px) - clamp(6px, 0.52vw, 10px))',
    width: 'clamp(100px, 6.87vw, 135px)',
    height: 'clamp(28px, 1.88vw, 36px)',
    backgroundColor: '#232323',
    zIndex: 10
  }}
>
  <span 
    style={{
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: 'clamp(10px, 0.73vw, 14px)',
      color: '#FFFFFF'
    }}
  >
    CyberPunk
  </span>
</div>

{renderSlidingImage('myth-cats', col2, {
    left: '72.2vw',
    top: '-0.5vh',
    width: '7.29vw',
    height: '7.29vw',
    border: '4px solid #FE0000'
  }, (e) => {
    e.target.onerror = null;
    e.target.src = col2;
  })}

<div 
  className="absolute flex items-center justify-center"
  style={{
    left: 'calc(72.2vw + clamp(2px, 0.26vw, 4px))',
    top: 'calc(-0.5vh + 7.29vw - clamp(28px, 2.08vw, 40px) - clamp(6px, 0.52vw, 10px))',
    width: 'clamp(100px, 6.87vw, 135px)',
    height: 'clamp(28px, 1.88vw, 36px)',
    backgroundColor: '#232323',
    zIndex: 10
  }}
>
  <span 
    style={{
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: 'clamp(10px, 0.73vw, 14px)',
      color: '#FFFFFF'
    }}
  >
    Myth Cats
  </span>
</div>

{renderSlidingImage('energy-near-you', col3, {
    left: '62.5vw',
    top: '20.5vh',
    width: '7.29vw',
    height: '7.29vw',
    border: '4px solid #FE0000'
  }, (e) => {
    e.target.onerror = null;
    e.target.src = col3;
  })}

<div 
  className="absolute flex items-center justify-center"
  style={{
    left: 'calc(62.5vw + clamp(2px, 0.26vw, 4px))',
    top: 'calc(20.5vh + 7.29vw - clamp(28px, 2.08vw, 40px) - clamp(6px, 0.52vw, 10px))',
    width: 'clamp(100px, 6.87vw, 135px)',
    height: 'clamp(28px, 1.88vw, 36px)',
    backgroundColor: '#232323',
    zIndex: 10
  }}
>
  <span 
    style={{
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: 'clamp(10px, 0.73vw, 14px)',
      color: '#FFFFFF'
    }}
  >
    Energy Near
  </span>
</div>

{renderSlidingImage('spirits-above', col4, {
    left: '72.2vw',
    top: '20.5vh',
    width: '7.29vw',
    height: '7.29vw',
    border: '4px solid #FE0000'
  }, (e) => {
    e.target.onerror = null;
    e.target.src = col4;
  })}

<div 
  className="absolute flex items-center justify-center"
  style={{
    left: 'calc(72.2vw + clamp(2px, 0.26vw, 4px))',
    top: 'calc(20.5vh + 7.29vw - clamp(28px, 2.08vw, 40px) - clamp(6px, 0.52vw, 10px))',
    width: 'clamp(100px, 6.87vw, 135px)',
    height: 'clamp(28px, 1.88vw, 36px)',
    backgroundColor: '#232323',
    zIndex: 10
  }}
>
  <span 
    style={{
      fontFamily: 'Keania One',
      fontWeight: 400,
      fontSize: 'clamp(10px, 0.73vw, 14px)',
      color: '#FFFFFF'
    }}
  >
    Spirits Above you
  </span>
</div>
          </div>
          </div>

          {/* Divider Line */}
          <div 
            style={{
              width: 'clamp(830.5px, 86.51vw, 1661px)',
              height: 'clamp(5.5px, 0.57vw, 11px)',
              backgroundColor: '#520001',
              marginTop: '0'
            }}
          />

          {/* Collection View Switcher */}
          <div 
            className="relative"
            style={{
              width: 'clamp(830px, 86.46vw, 1660px)',
              height: 'clamp(22.5px, 2.34vw, 45px)',
              backgroundColor: '#000000',
              borderBottom: 'clamp(0.5px, 0.05vw, 1px) solid #4D0304'
            }}
          >
            {/* Collection's Text */}
            <div 
              className="absolute"
              style={{
                left: 'clamp(22.5px, 2.34vw, 45px)',
                top: 'clamp(5.5px, 0.57vw, 11px)',
                fontFamily: 'Keania One',
                fontWeight: 400,
                fontSize: 'clamp(9px, 0.94vw, 18px)',
                color: 'rgba(255, 255, 255, 0.8)'
              }}
            >
              Collection's
            </div>

            {/* Grid View Icon (4 squares) */}
            <button
              onClick={() => setViewMode('grid')}
              className="absolute hover:opacity-80 transition-opacity"
              style={{
                left: 'clamp(769.5px, 80.16vw, 1539px)',
                top: 'clamp(5px, 0.52vw, 10px)',
                width: 'clamp(12.5px, 1.3vw, 25px)',
                height: 'clamp(12.5px, 1.3vw, 25px)',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: 0
              }}
            >
              {/* Top Left Square */}
              <div 
                className="absolute"
                style={{
                  left: '0',
                  top: '0',
                  width: 'clamp(5.5px, 0.57vw, 11px)',
                  height: 'clamp(5.5px, 0.57vw, 11px)',
                  backgroundColor: viewMode === 'grid' ? '#FFC863' : '#4D0304'
                }}
              />
              {/* Top Right Square */}
              <div 
                className="absolute"
                style={{
                  left: 'clamp(7px, 0.73vw, 14px)',
                  top: '0',
                  width: 'clamp(5.5px, 0.57vw, 11px)',
                  height: 'clamp(5.5px, 0.57vw, 11px)',
                  backgroundColor: viewMode === 'grid' ? '#FFC863' : '#4D0304'
                }}
              />
              {/* Bottom Left Square */}
              <div 
                className="absolute"
                style={{
                  left: '0',
                  top: 'clamp(7px, 0.73vw, 14px)',
                  width: 'clamp(5.5px, 0.57vw, 11px)',
                  height: 'clamp(5.5px, 0.57vw, 11px)',
                  backgroundColor: viewMode === 'grid' ? '#FFC863' : '#4D0304'
                }}
              />
              {/* Bottom Right Square */}
              <div 
                className="absolute"
                style={{
                  left: 'clamp(7px, 0.73vw, 14px)',
                  top: 'clamp(7px, 0.73vw, 14px)',
                  width: 'clamp(5.5px, 0.57vw, 11px)',
                  height: 'clamp(5.5px, 0.57vw, 11px)',
                  backgroundColor: viewMode === 'grid' ? '#FFC863' : '#4D0304'
                }}
              />
            </button>

            {/* List View Icon (4 squares + 4 lines) */}
            <button
              onClick={() => setViewMode('list')} 
              className="absolute hover:opacity-80 transition-opacity"
              style={{
                left: 'clamp(790.5px, 82.34vw, 1581px)',
                top: 'clamp(5px, 0.52vw, 10px)',
                width: 'clamp(18.5px, 1.93vw, 37px)',
                height: 'clamp(15.5px, 1.61vw, 31px)',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: 0
              }}
            >
              {/* Square 1 */}
              <div 
                className="absolute"
                style={{
                  left: '0',
                  top: '0',
                  width: 'clamp(2px, 0.21vw, 4px)',
                  height: 'clamp(2px, 0.21vw, 4px)',
                  backgroundColor: viewMode === 'list' ? '#FFC863' : '#4D0304'
                }}
              />
              {/* Square 2 */}
              <div 
                className="absolute"
                style={{
                  left: '0',
                  top: 'clamp(3.5px, 0.36vw, 7px)',
                  width: 'clamp(2px, 0.21vw, 4px)',
                  height: 'clamp(2px, 0.21vw, 4px)',
                  backgroundColor: viewMode === 'list' ? '#FFC863' : '#4D0304'
                }}
              />
              {/* Square 3 */}
              <div 
                className="absolute"
                style={{
                  left: '0',
                  top: 'clamp(7px, 0.73vw, 14px)',
                  width: 'clamp(2px, 0.21vw, 4px)',
                  height: 'clamp(2px, 0.21vw, 4px)',
                  backgroundColor: viewMode === 'list' ? '#FFC863' : '#4D0304'
                }}
              />
              {/* Square 4 */}
              <div 
                className="absolute"
                style={{
                  left: '0',
                  top: 'clamp(10.5px, 1.09vw, 21px)',
                  width: 'clamp(2px, 0.21vw, 4px)',
                  height: 'clamp(2px, 0.21vw, 4px)',
                  backgroundColor: viewMode === 'list' ? '#FFC863' : '#4D0304'
                }}
              />
              
              {/* Line 1 */}
              <div 
                className="absolute"
                style={{
                  left: 'clamp(3.5px, 0.36vw, 7px)',
                  top: '0',
                  width: 'clamp(16.5px, 1.72vw, 33px)',
                  height: 'clamp(2px, 0.21vw, 4px)',
                  backgroundColor: viewMode === 'list' ? '#FFC863' : '#4D0304'
                }}
              />
              {/* Line 2 */}
              <div 
                className="absolute"
                style={{
                  left: 'clamp(3.5px, 0.36vw, 7px)',
                  top: 'clamp(3.5px, 0.36vw, 7px)',
                  width: 'clamp(16.5px, 1.72vw, 33px)',
                  height: 'clamp(2px, 0.21vw, 4px)',
                  backgroundColor: viewMode === 'list' ? '#FFC863' : '#4D0304'
                }}
              />
              {/* Line 3 */}
              <div 
                className="absolute"
                style={{
                  left: 'clamp(3.5px, 0.36vw, 7px)',
                  top: 'clamp(7px, 0.73vw, 14px)',
                  width: 'clamp(16.5px, 1.72vw, 33px)',
                  height: 'clamp(2px, 0.21vw, 4px)',
                  backgroundColor: viewMode === 'list' ? '#FFC863' : '#4D0304'
                }}
              />
              {/* Line 4 */}
              <div 
                className="absolute"
                style={{
                  left: 'clamp(3.5px, 0.36vw, 7px)',
                  top: 'clamp(10.5px, 1.09vw, 21px)',
                  width: 'clamp(16.5px, 1.72vw, 33px)',
                  height: 'clamp(2px, 0.21vw, 4px)',
                  backgroundColor: viewMode === 'list' ? '#FFC863' : '#4D0304'
                }}
              />
            </button>
          </div>
          {/* Content Area - Grid или List View */}
          {viewMode === 'grid' ? (
            // Grid View - Карточки коллекций
            <div className="relative" style={{ 
              width: 'clamp(830px, 86.46vw, 1660px)', 
              minHeight: 'clamp(500px, 52vw, 1000px)' 
            }}>
              {/* Row 1 - Карточки 1-4 */}
              {/* Карточка 1 */}
              {(() => {
                const dbCol0 = getCollectionFromDB(collections[0].id);
                const collectionAmount0 = dbCol0?.nfts?.length || dbCol0?.stats?.amount || collections[0].collectionAmount;
                const followers0 = dbCol0?.stats?.followers || collections[0].followers;
                return (
              <div className="absolute" style={{ 
                left: 'clamp(9px, 0.94vw, 18px)', 
                top: 'clamp(16px, 1.67vw, 32px)'
              }}>
                <div
                  onClick={() => navigate(collections[0].route)}
                  className="flex-shrink-0 flex gap-0 overflow-hidden relative hover:opacity-90 transition-opacity cursor-pointer"
                  style={{ 
                    width: 'clamp(190px, 19.79vw, 380px)', 
                    height: 'clamp(105px, 10.94vw, 210px)' 
                  }}
                >
                  <div 
                    onClick={(e) => handleLikeToggle(e, collections[0].id, 0)}
                    className="absolute z-20 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
                    style={{
                      left: '0',
                      top: '0',
                      width: 'clamp(32px, 3.33vw, 64px)',
                      height: 'clamp(21px, 2.19vw, 42px)',
                      backgroundColor: 'rgba(20, 20, 20, 0.6)'
                    }}
                  >
                    <img 
                      src={isCollectionLiked(collections[0].id) ? likeIcon : unLikeIconImage}
                      alt={isCollectionLiked(collections[0].id) ? 'Remove from favorites' : 'Add to favorites'}
                      style={{
                        width: 'clamp(17px, 1.77vw, 34px)',
                        height: 'clamp(17px, 1.77vw, 34px)',
                        transform: animatingLikeIndex === 0 ? 'scale(1.5)' : 'scale(1)',
                        transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                      }}
                    />
                  </div>
                  <div className="bg-black overflow-hidden" style={{ width: 'clamp(120px, 12.5vw, 240px)', height: 'clamp(105px, 10.94vw, 210px)' }}>
                    <img src={collections[0].image} alt="Collection" className="w-full h-full object-cover" />
                  </div>
                  <div className="flex flex-col text-center relative" style={{ width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(105px, 10.94vw, 210px)', backgroundColor: 'rgba(18, 20, 38, 1)', borderTop: '2px solid #9F191A', borderRight: '2px solid #9F191A', borderBottom: '2px solid #9F191A', borderLeft: 'none' }}>
                    <div className="text-white font-normal absolute flex items-center justify-center" style={{ backgroundColor: '#9F191A', top: 'clamp(10px, 1.04vw, 20px)', left: '0', width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(13px, 1.35vw, 26px)', fontSize: 'clamp(6px, 0.63vw, 12px)', lineHeight: '1', opacity: 0.8 }}>{collections[0].title}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(28px, 2.92vw, 56px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Collection Amount</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(35.5px, 3.7vw, 71px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collectionAmount0}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(45px, 4.9vw, 92px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Best Offer</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(52.5px, 5.68vw, 107px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collections[0].bestOffer}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(64.5px, 6.93vw, 131px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Followers</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(72px, 7.71vw, 146px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{followers0}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(84px, 8.96vw, 170px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Status</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(91.5px, 9.74vw, 185px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>On Sale</div>
                  </div>
                </div>
              </div>
                );
              })()}

              {/* Карточка 2 */}
              {(() => {
                const dbCol1 = getCollectionFromDB(collections[1].id);
                const collectionAmount1 = dbCol1?.nfts?.length || dbCol1?.stats?.amount || collections[1].collectionAmount;
                const followers1 = dbCol1?.stats?.followers || collections[1].followers;
                return (
              <div className="absolute" style={{ left: 'clamp(215.5px, 22.45vw, 431px)', top: 'clamp(16px, 1.67vw, 32px)' }}>
                <div
                  onClick={() => navigate(collections[1].route)}
                  className="flex-shrink-0 flex gap-0 overflow-hidden relative hover:opacity-90 transition-opacity cursor-pointer"
                  style={{ width: 'clamp(190px, 19.79vw, 380px)', height: 'clamp(105px, 10.94vw, 210px)' }}
                >
                  <div 
                    onClick={(e) => handleLikeToggle(e, collections[1].id, 1)}
                    className="absolute z-20 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
                    style={{ left: '0', top: '0', width: 'clamp(32px, 3.33vw, 64px)', height: 'clamp(21px, 2.19vw, 42px)', backgroundColor: 'rgba(20, 20, 20, 0.6)' }}
                  >
                    <img 
                      src={isCollectionLiked(collections[1].id) ? likeIcon : unLikeIconImage} 
                      alt={isCollectionLiked(collections[1].id) ? 'Remove from favorites' : 'Add to favorites'} 
                      style={{ 
                        width: 'clamp(17px, 1.77vw, 34px)', 
                        height: 'clamp(17px, 1.77vw, 34px)',
                        transform: animatingLikeIndex === 1 ? 'scale(1.5)' : 'scale(1)',
                        transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                      }} 
                    />
                  </div>
                  <div className="bg-black overflow-hidden" style={{ width: 'clamp(120px, 12.5vw, 240px)', height: 'clamp(105px, 10.94vw, 210px)' }}>
                    <img src={collections[1].image} alt="Collection" className="w-full h-full object-cover" />
                  </div>
                  <div className="flex flex-col text-center relative" style={{ width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(105px, 10.94vw, 210px)', backgroundColor: 'rgba(18, 20, 38, 1)', borderTop: '2px solid #9F191A', borderRight: '2px solid #9F191A', borderBottom: '2px solid #9F191A', borderLeft: 'none' }}>
                    <div className="text-white font-normal absolute flex items-center justify-center" style={{ backgroundColor: '#9F191A', top: 'clamp(10px, 1.04vw, 20px)', left: '0', width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(13px, 1.35vw, 26px)', fontSize: 'clamp(6px, 0.63vw, 12px)', lineHeight: '1', opacity: 0.8 }}>{collections[1].title}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(28px, 2.92vw, 56px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Collection Amount</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(35.5px, 3.7vw, 71px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collectionAmount1}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(45px, 4.9vw, 92px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Best Offer</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(52.5px, 5.68vw, 107px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collections[1].bestOffer}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(64.5px, 6.93vw, 131px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Followers</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(72px, 7.71vw, 146px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{followers1}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(84px, 8.96vw, 170px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Status</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(91.5px, 9.74vw, 185px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>On Sale</div>
                  </div>
                </div>
              </div>
                );
              })()}

              {/* Карточка 3 */}
              {(() => {
                const dbCol2 = getCollectionFromDB(collections[2].id);
                const collectionAmount2 = dbCol2?.nfts?.length || dbCol2?.stats?.amount || collections[2].collectionAmount;
                const followers2 = dbCol2?.stats?.followers || collections[2].followers;
                return (
              <div className="absolute" style={{ left: 'clamp(422px, 43.96vw, 844px)', top: 'clamp(16px, 1.67vw, 32px)' }}>
                <div
                  onClick={() => navigate(collections[2].route)}
                  className="flex-shrink-0 flex gap-0 overflow-hidden relative hover:opacity-90 transition-opacity cursor-pointer"
                  style={{ width: 'clamp(190px, 19.79vw, 380px)', height: 'clamp(105px, 10.94vw, 210px)' }}
                >
                  <div 
                    onClick={(e) => handleLikeToggle(e, collections[2].id, 2)}
                    className="absolute z-20 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
                    style={{ left: '0', top: '0', width: 'clamp(32px, 3.33vw, 64px)', height: 'clamp(21px, 2.19vw, 42px)', backgroundColor: 'rgba(20, 20, 20, 0.6)' }}
                  >
                    <img 
                      src={isCollectionLiked(collections[2].id) ? likeIcon : unLikeIconImage} 
                      alt={isCollectionLiked(collections[2].id) ? 'Remove from favorites' : 'Add to favorites'} 
                      style={{ 
                        width: 'clamp(17px, 1.77vw, 34px)', 
                        height: 'clamp(17px, 1.77vw, 34px)',
                        transform: animatingLikeIndex === 2 ? 'scale(1.5)' : 'scale(1)',
                        transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                      }} 
                    />
                  </div>
                  <div className="bg-black overflow-hidden" style={{ width: 'clamp(120px, 12.5vw, 240px)', height: 'clamp(105px, 10.94vw, 210px)' }}>
                    <img src={collections[2].image} alt="Collection" className="w-full h-full object-cover" />
                  </div>
                  <div className="flex flex-col text-center relative" style={{ width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(105px, 10.94vw, 210px)', backgroundColor: 'rgba(18, 20, 38, 1)', borderTop: '2px solid #9F191A', borderRight: '2px solid #9F191A', borderBottom: '2px solid #9F191A', borderLeft: 'none' }}>
                    <div className="text-white font-normal absolute flex items-center justify-center" style={{ backgroundColor: '#9F191A', top: 'clamp(10px, 1.04vw, 20px)', left: '0', width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(13px, 1.35vw, 26px)', fontSize: 'clamp(6px, 0.63vw, 12px)', lineHeight: '1', opacity: 0.8 }}>{collections[2].title}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(28px, 2.92vw, 56px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Collection Amount</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(35.5px, 3.7vw, 71px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collectionAmount2}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(45px, 4.9vw, 92px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Best Offer</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(52.5px, 5.68vw, 107px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collections[2].bestOffer}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(64.5px, 6.93vw, 131px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Followers</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(72px, 7.71vw, 146px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{followers2}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(84px, 8.96vw, 170px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Status</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(91.5px, 9.74vw, 185px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>On Sale</div>
                  </div>
                </div>
              </div>
                );
              })()}

              {/* Карточка 4 */}
              {(() => {
                const dbCol3 = getCollectionFromDB(collections[3].id);
                const collectionAmount3 = dbCol3?.nfts?.length || dbCol3?.stats?.amount || collections[3].collectionAmount;
                const followers3 = dbCol3?.stats?.followers || collections[3].followers;
                return (
              <div className="absolute" style={{ left: 'clamp(629px, 65.52vw, 1258px)', top: 'clamp(16px, 1.67vw, 32px)' }}>
                <div
                  onClick={() => navigate(collections[3].route)}
                  className="flex-shrink-0 flex gap-0 overflow-hidden relative hover:opacity-90 transition-opacity cursor-pointer"
                  style={{ width: 'clamp(190px, 19.79vw, 380px)', height: 'clamp(105px, 10.94vw, 210px)' }}
                >
                  <div 
                    onClick={(e) => handleLikeToggle(e, collections[3].id, 3)}
                    className="absolute z-20 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
                    style={{ left: '0', top: '0', width: 'clamp(32px, 3.33vw, 64px)', height: 'clamp(21px, 2.19vw, 42px)', backgroundColor: 'rgba(20, 20, 20, 0.6)' }}
                  >
                    <img 
                      src={isCollectionLiked(collections[3].id) ? likeIcon : unLikeIconImage} 
                      alt={isCollectionLiked(collections[3].id) ? 'Remove from favorites' : 'Add to favorites'} 
                      style={{ 
                        width: 'clamp(17px, 1.77vw, 34px)', 
                        height: 'clamp(17px, 1.77vw, 34px)',
                        transform: animatingLikeIndex === 3 ? 'scale(1.5)' : 'scale(1)',
                        transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                      }} 
                    />
                  </div>
                  <div className="bg-black overflow-hidden" style={{ width: 'clamp(120px, 12.5vw, 240px)', height: 'clamp(105px, 10.94vw, 210px)' }}>
                    <img src={collections[3].image} alt="Collection" className="w-full h-full object-cover" />
                  </div>
                  <div className="flex flex-col text-center relative" style={{ width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(105px, 10.94vw, 210px)', backgroundColor: 'rgba(18, 20, 38, 1)', borderTop: '2px solid #9F191A', borderRight: '2px solid #9F191A', borderBottom: '2px solid #9F191A', borderLeft: 'none' }}>
                    <div className="text-white font-normal absolute flex items-center justify-center" style={{ backgroundColor: '#9F191A', top: 'clamp(10px, 1.04vw, 20px)', left: '0', width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(13px, 1.35vw, 26px)', fontSize: 'clamp(6px, 0.63vw, 12px)', lineHeight: '1', opacity: 0.8 }}>{collections[3].title}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(28px, 2.92vw, 56px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Collection Amount</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(35.5px, 3.7vw, 71px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collectionAmount3}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(45px, 4.9vw, 92px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Best Offer</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(52.5px, 5.68vw, 107px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collections[3].bestOffer}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(64.5px, 6.93vw, 131px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Followers</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(72px, 7.71vw, 146px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{followers3}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(84px, 8.96vw, 170px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Status</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(91.5px, 9.74vw, 185px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>On Sale</div>
                  </div>
                </div>
              </div>
                );
              })()}

              {/* Row 2 - Карточки 5-8 */}
              {/* Карточка 5 */}
              {(() => {
                const dbCol4 = getCollectionFromDB(collections[4].id);
                const collectionAmount4 = dbCol4?.nfts?.length || dbCol4?.stats?.amount || collections[4].collectionAmount;
                const followers4 = dbCol4?.stats?.followers || collections[4].followers;
                return (
              <div className="absolute" style={{ left: 'clamp(9px, 0.94vw, 18px)', top: 'clamp(139px, 14.48vw, 278px)' }}>
                <div
                  onClick={() => navigate(collections[4].route)}
                  className="flex-shrink-0 flex gap-0 overflow-hidden relative hover:opacity-90 transition-opacity cursor-pointer"
                  style={{ width: 'clamp(190px, 19.79vw, 380px)', height: 'clamp(105px, 10.94vw, 210px)' }}
                >
                  <div 
                    onClick={(e) => handleLikeToggle(e, collections[4].id, 4)}
                    className="absolute z-20 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
                    style={{ left: '0', top: '0', width: 'clamp(32px, 3.33vw, 64px)', height: 'clamp(21px, 2.19vw, 42px)', backgroundColor: 'rgba(20, 20, 20, 0.6)' }}
                  >
                    <img 
                      src={isCollectionLiked(collections[4].id) ? likeIcon : unLikeIconImage} 
                      alt={isCollectionLiked(collections[4].id) ? 'Remove from favorites' : 'Add to favorites'} 
                      style={{ 
                        width: 'clamp(17px, 1.77vw, 34px)', 
                        height: 'clamp(17px, 1.77vw, 34px)',
                        transform: animatingLikeIndex === 4 ? 'scale(1.5)' : 'scale(1)',
                        transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                      }} 
                    />
                  </div>
                  <div className="bg-black overflow-hidden" style={{ width: 'clamp(120px, 12.5vw, 240px)', height: 'clamp(105px, 10.94vw, 210px)' }}>
                    <img src={collections[4].image} alt="Collection" className="w-full h-full object-cover" />
                  </div>
                  <div className="flex flex-col text-center relative" style={{ width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(105px, 10.94vw, 210px)', backgroundColor: 'rgba(18, 20, 38, 1)', borderTop: '2px solid #9F191A', borderRight: '2px solid #9F191A', borderBottom: '2px solid #9F191A', borderLeft: 'none' }}>
                    <div className="text-white font-normal absolute flex items-center justify-center" style={{ backgroundColor: '#9F191A', top: 'clamp(10px, 1.04vw, 20px)', left: '0', width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(13px, 1.35vw, 26px)', fontSize: 'clamp(6px, 0.63vw, 12px)', lineHeight: '1', opacity: 0.8 }}>{collections[4].title}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(28px, 2.92vw, 56px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Collection Amount</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(35.5px, 3.7vw, 71px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collectionAmount4}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(45px, 4.9vw, 92px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Best Offer</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(52.5px, 5.68vw, 107px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collections[4].bestOffer}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(64.5px, 6.93vw, 131px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Followers</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(72px, 7.71vw, 146px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{followers4}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(84px, 8.96vw, 170px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Status</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(91.5px, 9.74vw, 185px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>On Sale</div>
                  </div>
                </div>
              </div>
                );
              })()}

              {/* Карточка 6 */}
              {(() => {
                const dbCol5 = getCollectionFromDB(collections[5].id);
                const collectionAmount5 = dbCol5?.nfts?.length || dbCol5?.stats?.amount || collections[5].collectionAmount;
                const followers5 = dbCol5?.stats?.followers || collections[5].followers;
                return (
              <div className="absolute" style={{ left: 'clamp(215.5px, 22.45vw, 431px)', top: 'clamp(139px, 14.48vw, 278px)' }}>
                <div
                  onClick={() => navigate(collections[5].route)}
                  className="flex-shrink-0 flex gap-0 overflow-hidden relative hover:opacity-90 transition-opacity cursor-pointer"
                  style={{ width: 'clamp(190px, 19.79vw, 380px)', height: 'clamp(105px, 10.94vw, 210px)' }}
                >
                  <div 
                    onClick={(e) => handleLikeToggle(e, collections[5].id, 5)}
                    className="absolute z-20 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
                    style={{ left: '0', top: '0', width: 'clamp(32px, 3.33vw, 64px)', height: 'clamp(21px, 2.19vw, 42px)', backgroundColor: 'rgba(20, 20, 20, 0.6)' }}
                  >
                    <img 
                      src={isCollectionLiked(collections[5].id) ? likeIcon : unLikeIconImage} 
                      alt={isCollectionLiked(collections[5].id) ? 'Remove from favorites' : 'Add to favorites'} 
                      style={{ 
                        width: 'clamp(17px, 1.77vw, 34px)', 
                        height: 'clamp(17px, 1.77vw, 34px)',
                        transform: animatingLikeIndex === 5 ? 'scale(1.5)' : 'scale(1)',
                        transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                      }} 
                    />
                  </div>
                  <div className="bg-black overflow-hidden" style={{ width: 'clamp(120px, 12.5vw, 240px)', height: 'clamp(105px, 10.94vw, 210px)' }}>
                    <img src={collections[5].image} alt="Collection" className="w-full h-full object-cover" />
                  </div>
                  <div className="flex flex-col text-center relative" style={{ width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(105px, 10.94vw, 210px)', backgroundColor: 'rgba(18, 20, 38, 1)', borderTop: '2px solid #9F191A', borderRight: '2px solid #9F191A', borderBottom: '2px solid #9F191A', borderLeft: 'none' }}>
                    <div className="text-white font-normal absolute flex items-center justify-center" style={{ backgroundColor: '#9F191A', top: 'clamp(10px, 1.04vw, 20px)', left: '0', width: 'clamp(70px, 7.29vw, 140px)', height: 'clamp(13px, 1.35vw, 26px)', fontSize: 'clamp(6px, 0.63vw, 12px)', lineHeight: '1', opacity: 0.8 }}>{collections[5].title}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(28px, 2.92vw, 56px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Collection Amount</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(35.5px, 3.7vw, 71px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collectionAmount5}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(45px, 4.9vw, 92px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Best Offer</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(52.5px, 5.68vw, 107px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{collections[5].bestOffer}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(64.5px, 6.93vw, 131px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Followers</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(72px, 7.71vw, 146px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>{followers5}</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(84px, 8.96vw, 170px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>Status</div>
                    <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)', top: 'clamp(91.5px, 9.74vw, 185px)', fontSize: 'clamp(5px, 0.52vw, 10px)', color: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', width: '100%' }}>On Sale</div>
                  </div>
                </div>
              </div>
                );
              })()}
            </div>
          ) : (
            // List View - Таблица коллекций
            <div className="relative" style={{ 
              width: 'clamp(830px, 86.46vw, 1660px)', 
              minHeight: 'clamp(500px, 52vw, 1000px)'
            }}>
              {/* Заголовки таблицы */}
              {/* # */}
              <div className="absolute"
                style={{
                  left: 'clamp(26px, 2.6vw, 50px)',
                  top: 'clamp(16px, 1.67vw, 32px)',
                  fontFamily: 'Alata, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(14px, 0.94vw, 18px)',
                  color: 'rgba(255, 255, 255, 0.9)'
                }}
              >
                #
              </div>

              {/* Collection */}
              <div className="absolute"
                style={{
                  left: 'clamp(87px, 8.75vw, 168px)',
                  top: 'clamp(16px, 1.67vw, 32px)',
                  fontFamily: 'Keania One, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(14px, 0.94vw, 18px)',
                  color: 'rgba(255, 255, 255, 0.9)'
                }}
              >
                Collection
              </div>

              {/* On Sale Piece's */}
              <div className="absolute"
                style={{
                  left: 'clamp(290px, 29.01vw, 557px)',
                  top: 'clamp(16px, 1.67vw, 32px)',
                  fontFamily: 'Keania One, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(14px, 0.94vw, 18px)',
                  color: 'rgba(255, 255, 255, 0.9)'
                }}
              >
                On Sale Piece's
              </div>

              {/* Best Offer */}
              <div className="absolute"
                style={{
                  left: 'clamp(425px, 42.5vw, 816px)',
                  top: 'clamp(16px, 1.67vw, 32px)',
                  fontFamily: 'Keania One, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(14px, 0.94vw, 18px)',
                  color: 'rgba(255, 255, 255, 0.9)'
                }}
              >
                Followers
              </div>

              {/* Followers */}
              <div className="absolute"
                style={{
                  left: 'clamp(537px, 53.7vw, 1031px)',
                  top: 'clamp(16px, 1.67vw, 32px)',
                  fontFamily: 'Keania One, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(14px, 0.94vw, 18px)',
                  color: 'rgba(255, 255, 255, 0.9)'
                }}
              >
                Best Offer
              </div>

              {/* Volume */}
              <div className="absolute"
                style={{
                  left: 'clamp(648px, 64.84vw, 1245px)',
                  top: 'clamp(16px, 1.67vw, 32px)',
                  fontFamily: 'Keania One, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(14px, 0.94vw, 18px)',
                  color: 'rgba(255, 255, 255, 0.9)'
                }}
              >
                Volume
              </div>

              {/* Rating */}
              <div className="absolute"
                style={{
                  left: 'clamp(754px, 75.47vw, 1449px)',
                  top: 'clamp(16px, 1.67vw, 32px)',
                  fontFamily: 'Keania One, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(14px, 0.94vw, 18px)',
                  color: 'rgba(255, 255, 255, 0.9)'
                }}
              >
                Rating
              </div>

              {/* Строки таблицы */}
              {dbCollections.length > 0 ? dbCollections.slice(0, 6).map((collection, index) => {
                const topPosition = 85 + (index * 55);
                const numberTopPosition = 94 + (index * 55);
                
                return (
                  <div key={collection.id || index}>
                    {/* Номер строки */}
                    <div className="absolute"
                      style={{
                        left: 'clamp(26px, 2.6vw, 50px)',
                        top: `clamp(${numberTopPosition - 20}px, ${(numberTopPosition/1080)*100}vh, ${numberTopPosition}px)`,
                        fontFamily: 'Alata, sans-serif',
                        fontWeight: 400,
                        fontSize: 'clamp(12px, 0.83vw, 16px)',
                        color: 'rgba(255, 255, 255, 0.9)'
                      }}
                    >
                      {index + 1}.
                    </div>

                    {/* Элемент строки */}
                    <div 
                      className="absolute cursor-pointer hover:opacity-90 transition-opacity"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (collection.slug) {
                          console.log('Navigating to:', `/collection/${collection.slug}`);
                          navigate(`/collection/${collection.slug}`);
                        } else {
                          console.warn('Collection slug is missing:', collection);
                        }
                      }}
                      style={{
                        left: 'clamp(42px, 4.22vw, 81px)',
                        top: `clamp(${topPosition - 20}px, ${(topPosition/1080)*100}vh, ${topPosition}px)`,
                        width: 'clamp(730px, 77.5vw, 1490px)',
                        height: 'clamp(30px, 2.08vw, 40px)',
                        borderTop: '1px solid rgba(186, 3, 3, 0.4)',
                        borderBottom: '1px solid rgba(186, 3, 3, 0.4)',
                        backgroundColor: 'transparent',
                        zIndex: 1
                      }}
                    >
                      {/* Иконка */}
                      <img 
                        src={require('../assets/Like_icon2.png')}
                        alt="Like"
                        className="absolute"
                        style={{
                          left: 'clamp(6px, 0.63vw, 12px)',
                          top: 'clamp(4px, 0.42vw, 8px)',
                          width: 'clamp(18px, 1.25vw, 24px)',
                          height: 'clamp(18px, 1.25vw, 24px)',
                          pointerEvents: 'none'
                        }}
                      />

                      {/* Название коллекции */}
                      <div className="absolute"
                        style={{
                          left: 'clamp(30px, 3.75vw, 71px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontFamily: 'Keania One, sans-serif',
                          fontWeight: 400,
                          fontSize: 'clamp(12px, 0.83vw, 16px)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          pointerEvents: 'none'
                        }}
                      >
                        {collection.title || collection.collectionName || `Collection ${index + 1}`}
                      </div>

                      {/* On Sale Piece's */}
                      <div className="absolute"
                        style={{
                          left: 'clamp(293px, 27vw, 516px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontFamily: 'Keania One, sans-serif',
                          fontWeight: 400,
                          fontSize: 'clamp(12px, 0.83vw, 16px)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          pointerEvents: 'none'
                        }}
                      >
                        0
                      </div>

                      {/* Best Offer - количество пользователей в waiting list */}
                      <div className="absolute"
                        style={{
                          left: 'clamp(408px, 40.1vw, 775px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontFamily: 'Keania One, sans-serif',
                          fontWeight: 400,
                          fontSize: 'clamp(12px, 0.83vw, 16px)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          pointerEvents: 'none'
                        }}
                      >
                        {collection.waitingListCount || 0}
                      </div>

                      {/* Followers */}
                      <div className="absolute"
                        style={{
                          left: 'clamp(515px, 51vw, 970px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontFamily: 'Keania One, sans-serif',
                          fontWeight: 400,
                          fontSize: 'clamp(12px, 0.83vw, 16px)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          pointerEvents: 'none'
                        }}
                      >
                        0
                      </div>

                      {/* Volume */}
                      <div className="absolute"
                        style={{
                          left: 'clamp(606px, 60.6vw, 1164px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontFamily: 'Keania One, sans-serif',
                          fontWeight: 400,
                          fontSize: 'clamp(12px, 0.83vw, 16px)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          pointerEvents: 'none'
                        }}
                      >
                        133.45 sat
                      </div>

                      {/* Rating */}
                      <div className="absolute"
                        style={{
                          left: 'clamp(692px, 71.7vw, 1378px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          fontFamily: 'Keania One, sans-serif',
                          fontWeight: 400,
                          fontSize: 'clamp(12px, 0.83vw, 16px)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          pointerEvents: 'none'
                        }}
                      >
                        3.44
                      </div>
                    </div>
                  </div>
                );
              }) : (
                // Fallback если коллекции еще не загружены
                [1, 2, 3, 4, 5, 6].map((item, index) => {
                  const topPosition = 85 + (index * 55);
                  const numberTopPosition = 94 + (index * 55);
                  
                  return (
                    <div key={index}>
                      {/* Номер строки */}
                      <div className="absolute"
                        style={{
                          left: 'clamp(26px, 2.6vw, 50px)',
                          top: `clamp(${numberTopPosition - 20}px, ${(numberTopPosition/1080)*100}vh, ${numberTopPosition}px)`,
                          fontFamily: 'Alata, sans-serif',
                          fontWeight: 400,
                          fontSize: 'clamp(12px, 0.83vw, 16px)',
                          color: 'rgba(255, 255, 255, 0.9)'
                        }}
                      >
                        {item}.
                      </div>

                      {/* Элемент строки */}
                      <div className="absolute"
                        style={{
                          left: 'clamp(42px, 4.22vw, 81px)',
                          top: `clamp(${topPosition - 20}px, ${(topPosition/1080)*100}vh, ${topPosition}px)`,
                          width: 'clamp(730px, 77.5vw, 1490px)',
                          height: 'clamp(30px, 2.08vw, 40px)',
                          borderTop: '1px solid rgba(186, 3, 3, 0.4)',
                          borderBottom: '1px solid rgba(186, 3, 3, 0.4)',
                          backgroundColor: 'transparent'
                        }}
                      >
                        {/* Иконка */}
                        <img 
                          src={require('../assets/Like_icon2.png')}
                          alt="Like"
                          className="absolute"
                          style={{
                            left: 'clamp(6px, 0.63vw, 12px)',
                            top: 'clamp(4px, 0.42vw, 8px)',
                            width: 'clamp(18px, 1.25vw, 24px)',
                            height: 'clamp(18px, 1.25vw, 24px)'
                          }}
                        />

                        {/* Название коллекции */}
                        <div className="absolute"
                          style={{
                            left: 'clamp(30px, 3.75vw, 71px)',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontFamily: 'Keania One, sans-serif',
                            fontWeight: 400,
                            fontSize: 'clamp(12px, 0.83vw, 16px)',
                            color: 'rgba(255, 255, 255, 0.8)'
                          }}
                        >
                          Loading...
                        </div>

                        {/* On Sale Piece's */}
                        <div className="absolute"
                          style={{
                            left: 'clamp(293px, 27vw, 516px)',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontFamily: 'Keania One, sans-serif',
                            fontWeight: 400,
                            fontSize: 'clamp(12px, 0.83vw, 16px)',
                            color: 'rgba(255, 255, 255, 0.8)'
                          }}
                        >
                          0
                        </div>

                        {/* Best Offer */}
                        <div className="absolute"
                          style={{
                            left: 'clamp(408px, 40.1vw, 775px)',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontFamily: 'Keania One, sans-serif',
                            fontWeight: 400,
                            fontSize: 'clamp(12px, 0.83vw, 16px)',
                            color: 'rgba(255, 255, 255, 0.8)'
                          }}
                        >
                          1.44 Sal
                        </div>

                        {/* Followers */}
                        <div className="absolute"
                          style={{
                            left: 'clamp(515px, 51vw, 970px)',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontFamily: 'Keania One, sans-serif',
                            fontWeight: 400,
                            fontSize: 'clamp(12px, 0.83vw, 16px)',
                            color: 'rgba(255, 255, 255, 0.8)'
                          }}
                        >
                          0
                        </div>

                        {/* Volume */}
                        <div className="absolute"
                          style={{
                            left: 'clamp(606px, 60.6vw, 1164px)',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontFamily: 'Keania One, sans-serif',
                            fontWeight: 400,
                            fontSize: 'clamp(12px, 0.83vw, 16px)',
                            color: 'rgba(255, 255, 255, 0.8)'
                          }}
                        >
                          133.45 sat
                        </div>

                        {/* Rating */}
                        <div className="absolute"
                          style={{
                            left: 'clamp(692px, 71.7vw, 1378px)',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontFamily: 'Keania One, sans-serif',
                            fontWeight: 400,
                            fontSize: 'clamp(12px, 0.83vw, 16px)',
                            color: 'rgba(255, 255, 255, 0.8)'
                          }}
                        >
                          3.44
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}
          </div>
          </div>
          <Footer />
        </main>
      </div>
      <AuthModal 
        isOpen={isAuthModalOpen} 
        onClose={() => setIsAuthModalOpen(false)} 
      />
    </div>
  );
}